<template>
  <div>
    <div v-show="isFormReady">
      <form :id="'mktoForm_' + id"></form>
    </div>

    <loader v-if="isFormLoading" loader-style="spinner"></loader>
    <salesforce-form
      v-if="hasFormTimedOut"
      :show-headers="''"
    ></salesforce-form>
  </div>
</template>

<script>
/* globals dataLayer, optimizely, MktoForms2 */
import _ from 'underscore';
import $ from 'jquery';
import cookie from 'js-cookie';
import mktoAnalytics from './marketo-analytics';
import mktoSetup from './marketo-setup';
import mktoSteps from './marketo-steps';
import mktoPrefill from './marketo-prefill';
import mktoStepsAutofill from './marketo-steps-autofill';
import cookies from '../../../helpers/cookies';
import parseParams from '../../../helpers/parse-parameters';
import Loader from '../loader/Loader.vue';
import SalesforceForm from '../form/SalesforceForm.vue';
import formAnalytics from '../form/form-analytics';

const FORM_STATES = {
  initial: 'INITIAL',
  ready: 'READY',
  timeout: 'TIMEOUT',
  submitted: 'SUBMITTED'
};

export default {
  props: [
    'id',
    'cta',
    'redirect',
    'steps',
    'stepsText',
    'stepsShowFirst',
    'nonProgressiveFields',
    'confirmMessage',
    'confirmRedirect',
    'preventLoad',
    'optimizelyPrefix',
    'optimizelySubmitPrefix',
    'gaPrefix',
    'queryParamPrefill'
  ],
  data() {
    return {
      lightbox: null,
      form: null,
      formIsSet: false,
      formState: FORM_STATES.initial,
      defaultNonProgressive: [
        'Number_of_Registers__c',
        'Number_of_Locations__c'
      ],
      moveFirstBack: false,
      setInitialListeners: false,
      step: 1,
      stepsTotal: 0,
      skipSteps: [],
      stepsWithEvents: [],
      isLightboxOpened: false
    };
  },

  computed: {
    lightboxToggled() {
      return this.$root.lightboxToggled;
    },
    isFormLoading(){
      return this.formState === FORM_STATES.initial;
    },
    isFormReady(){
      return this.formState === FORM_STATES.ready;
    },
    hasFormTimedOut(){
      return this.formState === FORM_STATES.timeout;
    },
  },

  components: {
    Loader,
    SalesforceForm
  },

  methods: {
    loadForm() {
      MktoForms2.loadForm(
        '//app-ab01.marketo.com',
        '169-JJW-529',
        this.id,
        (form) => {
          if (form.getId() === Number(this.id)) {
            const button = form.getFormElem().find('button');
            const event = this.steps ? 'PSG' : 'webForm';
            dataLayer.push({
              event,
              formAction: 'Load',
              formId: this.id,
              fieldValue: this.cta,
              formType: this.lightbox < 0 ? 'Inline' : 'Popup'
            });

            if (!this.steps) {
              button.on('click', () => {
                mktoAnalytics.setErrors(form);
              });
            }

            form.onSuccess(() => {
              const parameters = parseParams(window.location.search);
              const optimizelyPrefix =
                this.optimizelySubmitPrefix || this.optimizelyPrefix;
              cookies.setMarketoLead();
              cookies.setMarketoLeadInfo(form);
              mktoAnalytics.setOptimizelyEvents(optimizelyPrefix, 'Submit');
              mktoAnalytics.optimizelyXEvent('form-submit');
              dataLayer.push({
                event,
                formAction: 'Submit',
                formId: this.id,
                fieldValue: this.cta,
                formType: this.lightbox < 0 ? 'Inline' : 'Popup'
              });

              if (parameters.subid !== undefined) {
                const body = document.querySelector('body');
                const pixel = document.createElement('img');
                pixel.src = `//api.naturaltracking.com/api/server_to_server_events/track/?aff_sid1=${parameters.subid}`;
                pixel.height = 1;
                pixel.width = 1;
                pixel.style.display = 'none';
                body.appendChild(pixel);
              }
            });
          }
        }
      );
    },

    setCta() {
      const cta = this.cta;
      const form = this.form;

      form
        .getFormElem()
        .find('.mktoButton')
        .text(cta);
    },

    setRedirect() {
      const form = this.form;
      const redirect = this.redirect;

      form.onSuccess(() => {
        window.location = redirect;
        return false;
      });
    },

    setConfirmMessage() {
      const confirmMessage = this.confirmMessage;
      const confirmRedirect = this.confirmRedirect;
      const form = this.form;

      form.onSuccess(() => {
        if (this.lightbox > -1) {
          mktoAnalytics.setVirtualThankYouPage();
        }

        const yPostion = form
          .getFormElem()
          .parent()
          .offset().top;

        form
          .getFormElem()
          .parent()
          .children()
          .not('.lightbox__close')
          .hide();

        form
          .getFormElem()
          .parent()
          .append(confirmMessage);

        window.scrollTo(0, yPostion - 100);

        document.querySelector(`#lightboxMarketoBtn`).style.display = 'none';

        const confirmItems = document.querySelectorAll(
          '.mktoConfirm__button, .mktoConfirm__image'
        );
        _.each(confirmItems, (item) => {
          item.addEventListener('click', () => {
            mktoAnalytics.setOptimizelyEvents(
              this.optimizelyPrefix,
              'Download'
            );
            window.location.href = confirmRedirect;
          });
        });
        return false;
      });
    },

    setToSteps() {
      const id = this.id;
      const prefix = this.optimizelyPrefix || '';
      const nonProgressive = (this.nonProgressiveFields || []).concat(
        this.defaultNonProgressive
      );
      const form = this.form;
      const button = form.getFormElem().find('button');
      const fieldsets = form.getFormElem().find('fieldset');
      this.stepsTotal = fieldsets.length;

      document.querySelector(`#mktoForm_${id}`).style.display = 'none';

      this.initSteps(form, fieldsets, button, nonProgressive, id);

      button.on('click', (e) => {
        mktoAnalytics.setErrors(form, this.step);
        if (mktoSteps.inputIsInvalid(fieldsets[this.step - 1], form)) {
          e.preventDefault();
          return;
        }
        if (this.step < this.stepsTotal) {
          e.preventDefault();
        }
        this.resumeSteps(this.$root.marketoInitialStep, this.stepsTotal, e);
        mktoAnalytics.setSteps(
          this.step,
          this.stepsTotal,
          e,
          prefix,
          this.gaPrefix
        );
        this.step += 1;
        while (this.skipSteps.indexOf(this.step) !== -1) {
          this.step++;
        }
        this.setStep(button, fieldsets, nonProgressive, id);
        if (fieldsets[this.step - 1]) {
          this.$root.marketoCurrentStepId = fieldsets[
            this.step - 1
          ].querySelectorAll('select, input')[0].id;
        }
        this.$root.marketoCurrentStep = this.step;
      });

      this.formIsSet = true;
      this.autofillMultipleForms();
    },

    resumeSteps(initialStep, steps, e) {
      if (initialStep > 1 && !this.$root.marketoStepResumed) {
        const formAction = 'Resume';
        const fieldValue = e.currentTarget.innerText;
        const formStep = initialStep;
        const gaEvent = this.gaPrefix ? `${this.gaPrefix} PSG` : 'PSG';
        dataLayer.push({ event: gaEvent, formAction, fieldValue, formStep });
        this.$root.marketoStepResumed = true;
      }
    },

    moveFirstStep() {
      const id = this.id;
      const formEl = document.querySelector(`#mktoForm_${id}`);
      const tempContainer = document.querySelector('.mkto-first-step__wrapper');
      const mainContainer = document.querySelector(
        '.lightbox[for="lightboxMarketo"] .lightbox__wrapper'
      );
      const triggers = document.querySelectorAll(
        '.lightbox__button[for="lightboxMarketo"]'
      );
      const navUserAgent = navigator.userAgent.toLowerCase();

      tempContainer.appendChild(formEl);

      for (const trigger of triggers) {
        trigger.addEventListener('click', () => {
          this.moveFirstBack = true;
          mainContainer.appendChild(formEl);
          tempContainer.remove();
          if (
            navUserAgent.indexOf('safari') > -1 &&
            navUserAgent.indexOf('chrome') === -1
          ) {
            window.scrollTo(0, window.pageYOffset + 1);
            formEl.style.position = 'relative';
            formEl.style.top = '1px';
          }
        });
      }
    },

    setNonSteps() {
      const form = this.form;
      const button = form.getFormElem().find('button');
      this.formIsSet = true;

      button.on('click', (e) => {
        mktoAnalytics.setErrors(form);
        if (mktoSteps.inputIsInvalid(form.getFormElem()[0], form)) {
          e.preventDefault();
          return;
        }
      });
    },

    autofillMultipleForms() {
      if (!this.steps || this.$root.marketoCountForms <= 1) {
        return;
      }

      const nonProgressive = (this.nonProgressiveFields || []).concat(
        this.defaultNonProgressive
      );
      const form = this.form;
      const button = form.getFormElem().find('button');
      const fieldsets = form.getFormElem().find('fieldset');
      this.$root.connectedMarketoForms = true;
      this.stepsTotal = fieldsets.length;

      this.initSteps(form, fieldsets, button, nonProgressive, this.id);

      if (!this.setInitialListeners) {
        const selects = fieldsets[this.step - 1].querySelectorAll('select');
        const inputs = fieldsets[this.step - 1].querySelectorAll('input');

        _.each(selects, (select) => {
          select.addEventListener(
            'change',
            this.listenFirstChange(this.step, fieldsets)
          );
        });

        _.each(inputs, (input) => {
          input.addEventListener(
            'change',
            this.listenFirstChange(this.step, fieldsets)
          );
        });

        this.setInitialListeners = true;
      }
    },

    listenFirstChange(step, fieldsets) {
      return () => {
        if (!this.$root.marketoFormChanged) {
          this.$root.marketoCurrentStepId = fieldsets[
            step - 1
          ].querySelectorAll('select, input')[0].id;
          this.$root.marketoFormChanged = true;
        }
      };
    },

    initSteps(form, fieldsets, button, nonProgressive, id) {
      // form 2143 is a partners step lead, autofill is only a marketing functionality
      if (id !== 2143) {
        this.skipSteps = mktoStepsAutofill.call(
          this,
          form,
          this.stepsTotal,
          fieldsets
        );
      }
      while (this.skipSteps.indexOf(this.step) !== -1) {
        this.step++;
      }
      this.$root.marketoInitialStep = this.step;

      if (!this.stepsShowFirst || this.moveFirstBack) {
        this.setStep(button, fieldsets, nonProgressive, id);
      } else {
        MktoForms2.whenReady((mktoForm) => {
          if (mktoForm.getId() === Number(this.id)) {
            this.form = form;
            this.setStep(button, fieldsets, nonProgressive, id);
          }
        });
      }

      document.getElementById(`mktoForm_${id}`).style.display = 'block';
    },

    setStep(button, fieldsets, nonProgressive, id) {
      if (fieldsets[this.step - 1]) {
        const firstField = fieldsets[this.step - 1].querySelectorAll(
          'select, input'
        )[0];

        if (
          firstField.id === 'Business_Category__c' &&
          fieldsets[this.step - 1].querySelector('#Business_Category_Type__c')
            .value === ''
        ) {
          mktoSteps.setOptions.call(this, this.step, fieldsets, firstField);
        }
      }
      mktoSteps.setHash(this.step, this.stepsTotal);
      mktoSteps.setTextChange(
        this.step,
        this.stepsTotal,
        button,
        this.stepsText,
        this.cta,
        id
      );
      mktoSteps.setFieldsets(this.step, fieldsets, nonProgressive);

      if (!_.contains(this.stepsWithEvents, this.step)) {
        mktoSteps.inputChange.call(
          this,
          this.step,
          fieldsets,
          this.optimizelyPrefix,
          this.gaPrefix
        );
        this.stepsWithEvents.push(this.step);
      }
    },

    initLightboxToggled() {
      if (this.lightboxToggled === 'lightboxMarketo') {
        if (this.$parent.$parent.name === this.lightboxToggled) {
          mktoAnalytics.setOptimizelyEvents(
            this.optimizelyPrefix,
            'Click',
            this.$root.optimizelyPostfix
          );
        }

        if (this.steps && this.formIsSet === false) {
          this.setToSteps();
        } else if (!this.steps && this.formIsSet === false) {
          this.setNonSteps();
        }
      } else if (this.lightboxToggled === 'lightboxOptimizelyTest') {
        if (this.steps && !this.formIsSet) {
          this.setToSteps();
        }
      }

      this.autofillMultipleForms();
    },

    handleMarketoAPITimeout() {
      setTimeout(() => {
        if (this.formState !== FORM_STATES.ready) {
          //not sending fallback load event here, since we will get duplicate events since VueForm is sending this also
          // dataLayer.push({ 'event': 'webForm', 'formType': 'FallBack', 'formAction': 'Load', 'fieldValue': this.$root.lightboxCta});

          //due to timeout, this event might not have fired when lightbox is opened
          if (this.isLightboxOpened) {
            dataLayer.push({
              event: 'popup',
              popupType: 'FallBack',
              popupAction: 'Click',
              popupLabel: this.$root.lightboxCta
            });
          }

          this.formState = FORM_STATES.timeout;
        }
      }, 4000);
    },

    onLightboxOpened() {
      this.isLightboxOpened = true;
      if (this.formState === FORM_STATES.timeout) {
        dataLayer.push({
          event: 'popup',
          popupType: 'FallBack',
          popupAction: 'Click',
          popupLabel: this.$root.lightboxCta
        });
      }
    },

    onLightboxClosed() {
      this.isLightboxOpened = false;
      if (this.formState === FORM_STATES.timeout) {
        dataLayer.push({
          event: 'popup',
          popupType: 'FallBack',
          popupAction: 'Close',
          popupLabel: this.$root.lightboxCta
        });
      }
    }
  },

  mounted() {
    this.lightbox = this.$parent.$el.className
      .split(' ')
      .indexOf('lightbox__wrapper');

    this.handleMarketoAPITimeout();

    MktoForms2.whenReady((form) => {
      // Remove default marketo CSS
      $('#mktoForms2BaseStyle').remove();
      $('#mktoForms2ThemeStyle').remove();

      if (form.getId() === Number(this.id)) {
        this.form = form;
        this.formState = FORM_STATES.ready;
        mktoPrefill.init(form, this.queryParamPrefill);
        mktoSetup.fixSelectFlicker(form);
        mktoSetup.disableDefaultStyles(form);
        mktoSetup.disableFirstOption(form);
        mktoSetup.setPlaceholderColors(form);
        mktoSetup.setBusinessCategoryPlaceholder(
          form,
          cookie.get('_sk_vertical')
        );
        mktoSetup.setUserTimezone(form);
        mktoSetup.setUserDevice(form);
        mktoSetup.setLeadSubmissionUrl(form);
        mktoSetup.validateEmail(form);
        mktoSetup.setGaGuid(form);

        if (this.cta) {
          this.setCta();
        }

        if (this.redirect) {
          this.setRedirect();
        }

        if (this.confirmMessage) {
          this.setConfirmMessage();
        }

        if (this.lightbox < 0 && this.steps) {
          this.setToSteps();
        } else if (this.lightbox < 0) {
          this.setNonSteps();
        }

        if (this.stepsShowFirst) {
          this.setToSteps();
          this.moveFirstStep();
        }
      }
    });

    //have to use window.URLSearchParams or it will cause error in IE
    if (
      !this.preventLoad &&
      (!window.URLSearchParams ||
        new URLSearchParams(window.location.search).get(
          'force_fallback_form'
        ) !== 'true')
    ) {
      this.loadForm();
    }

    this.$root.marketoCountForms++;
  },

  watch: {
    lightboxToggled(newVal, oldVal) {
      if (!newVal && oldVal === this.$parent.lightboxName) {
        this.onLightboxClosed();
      } else if (newVal === this.$parent.lightboxName) {
        this.onLightboxOpened();
      }

      if (!this.form) {
        MktoForms2.whenReady((form) => {
          if (form.getId() === Number(this.id)) {
            this.form = form;
            this.initLightboxToggled();
          }
        });
      } else {
        this.initLightboxToggled();
      }
    }
  }
};
</script>
